<template>
  <div>
   

    <CRow>
      <CCol col="12" md="12">
        <CCard>
          <CCardBody>
            <CTabs add-tab-classes="mt-1">
              <CTab>
                <template slot="title">
                  <img src="img/cow-silhouette.svg" style="width:20px" />
                  {{tabs[0]}}
                </template>
              

               <FixedPlugin></FixedPlugin>
              </CTab>

              <!-- second -->

              <CTab>
                <template slot="title">
                  <img src="img/cow-silhouette.svg" style="width:20px" />
                  {{tabs[1]}}
                </template>
                <CCard>
                  <CCardBody>
                    <CRow>
                      <milkmaintance></milkmaintance>
                    </CRow>
                  </CCardBody>
                </CCard>
              </CTab>

              <!-- Third -->

              <CTab>
                <template slot="title">
                  <img src="img/cow-silhouette.svg" style="width:20px" />
                  {{tabs[2]}}
                </template>
                <CCard>
                  <CCardBody>
                    <CRow>
                      <pregnancy></pregnancy>
                    </CRow>
                  </CCardBody>
                </CCard>
              </CTab>
            </CTabs>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import CTableWrapper from "../../../tables/Table";
import { APIService } from "../../../../apiservice.js";
import milkmaintance from "./milkmaintance";
import pregnancy from "./pregnancy";
import Swal from "sweetalert2";
import FixedPlugin from "./FixedPlugin.vue";
export default {
  components: { CTableWrapper, milkmaintance, pregnancy, FixedPlugin },

  data() {
    return {
      isShowing: false,
      speciesItem: [],
      editSpecies: [],
      liveWeightfrom: "",
      liveWeightto: "",
      dry: "",
      s_p_fodder: "",
      dryM1: "",
      dryM2: "",
      dryM3: "",
      greenFodder: "",
      addButton: false,
      saveButton: false,
      deleteButton: false,
      addnewButton: true,
      cancelButton: false,
      EditsaveButton: false,
      options: ["Option 1", "Option 2", "Option 3"],
      tabs: ["Body Weight", "Maintance", "Pregnancy Month Wise "],
      fields: [
        {
          key: "liveWeightfrom",
          sortable: true,
        },
        {
          key: "liveWeightto",
          sortable: true,
        },
        {
          key: "dry",
          sortable: true,
        },
        {
          key: "s_p_fodder",
          sortable: true,
        },
        //  {
        //   key: "dryM1",
        //   sortable: true
        // },
        //     {
        //   key: "dryM2",
        //   sortable: true
        // },
        //   {
        //   key: "dryM3",
        //   sortable: true
        // },
        {
          key: "greenFodder",
          sortable: true,
        },
      ],
      //   items: [
      //     {
      //       isActive: true,
      //      Live_Weight_kg_From: "1",
      //       Live_Weight: "Murrah",
      //       Dry: "Buffalo",
      //          S_P_Foode: "1",
      //       DRY_M: "Murrah",
      //        DRY_M: "Buffalo",
      //        Green_Fodder: "Buffalo"
      //     },

      //   ],
      //  fields1: [
      //     {
      //       key: "Pregnancy_Days_From",
      //       sortable: true
      //     },
      //     {
      //       key: "Pregnancy_Days_To",
      //       sortable: true
      //     },
      //     {
      //       key: "Dry",
      //       sortable: true
      //     },
      //      {
      //       key: "S_P_Foode",
      //       sortable: true
      //     },
      //      {
      //       key: "DRY_M",
      //       sortable: true
      //     },
      //         {
      //       key: "DRY_M",
      //       sortable: true
      //     },
      //         {
      //       key: "Green_Fodder",
      //       sortable: true
      //     }
      //   ],
      //   items1: [

      //   ],
      //   fields2: [
      //     {
      //       key: "Milk_kg_From",
      //       sortable: true
      //     },
      //     {
      //       key: "Milk_Kg_To",
      //       sortable: true
      //     },
      //     {
      //       key: "Dry",
      //       sortable: true
      //     },
      //      {
      //       key: "S_P_Foode",
      //       sortable: true
      //     },
      //      {
      //       key: "DRY_M",
      //       sortable: true
      //     },
      //         {
      //       key: "DRY_M",
      //       sortable: true
      //     },
      //         {
      //       key: "Green_Fodder",
      //       sortable: true
      //     }
      //   ],
      //   items1: [

      //   ],
    };
  },
  methods: {
    getbodyWeightList() {
      APIService.bodyWeightList().then((res) => {
        if (res.status == 200) {
          this.speciesItem = res.data;

          this.liveWeightfrom = this.speciesItem[0].liveWeightfrom;
          this.liveWeightto = this.speciesItem[0].liveWeightto;
          this.dry = this.speciesItem[0].dry;
          this.s_p_fodder = this.speciesItem[0].s_p_fodder;
          this.dryM1 = this.speciesItem[0].dryM1;
          this.dryM2 = this.speciesItem[0].dryM2;
          this.dryM3 = this.speciesItem[0].dryM3;
          this.greenFodder = this.speciesItem[0].greenFodder;
        }
      });
    },
    rowClicked(item, index, column, e) {
      console.log("edit item", item, index, column, e);

      this.editSpecies = item;
      this.liveWeightfrom = item.liveWeightfrom;
      this.liveWeightto = item.liveWeightto;
      this.dry = item.dry;
      this.s_p_fodder = item.s_p_fodder;
      this.dryM1 = item.dryM1;
      this.dryM2 = item.dryM2;
      this.dryM3 = item.dryM3;
      this.greenFodder = item.greenFodder;
      this.addButton = false;
      this.saveButton = true;
      this.deleteButton = true;
      this.cancelButton = false;
      this.addnewButton = true;
      this.EditsaveButton = false;
    },
    addNewspecies() {
      this.liveWeightfrom = "";
      this.liveWeightto = "";
      this.dry = "";
      this.s_p_fodder = "";
      this.dryM1 = "";
      this.dryM2 = "";
      this.dryM3 = "";
      this.greenFodder = "";
      this.addButton = false;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = true;
      this.addnewButton = false;
      this.EditsaveButton = true;
      return getbodyWeightList();
    },
    Cancelspecies() {
      this.liveWeightfrom = "";
      this.liveWeightto = "";
      this.dry = "";
      this.s_p_fodder = "";
      this.dryM1 = "";
      this.dryM2 = "";
      this.dryM3 = "";
      this.greenFodder = "";
      this.addButton = false;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = false;
      this.addnewButton = true;
      (this.EditsaveButton = false), this.getbodyWeightList();
    },

    addSpecies() {
      let liveWeightfrom = this.liveWeightfrom;
      let liveWeightto = this.liveWeightto;
      let dry = this.dry;
      let s_p_fodder = this.s_p_fodder;
      let dryM1 = this.dryM1;
      let dryM2 = this.dryM2;
      let dryM3 = this.dryM3;
      let greenFodder = this.greenFodder;
      let data = {
        liveWeightfrom,
        liveWeightto,
        dry,
        s_p_fodder,
        dryM1,
        dryM2,
        dryM3,
        greenFodder,
      };
      APIService.saveBodyWeight(data).then((res) => {
        if (res.status == 200) {
          (this.liveWeightfrom = ""),
            (this.liveWeightto = ""),
            (this.dry = ""),
            (this.s_p_fodder = ""),
            (this.dryM1 = ""),
            (this.dryM2 = ""),
            (this.dryM3 = ""),
            (this.greenFodder = ""),
            this.getbodyWeightList();
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Data Saved Successfully",
            showConfirmButton: false,
            timer: 2000,
          });
        }
      });
    },
    updateSpecies() {
      let id = this.editSpecies._id;
      let liveWeightfrom = this.liveWeightfrom;
      let liveWeightto = this.liveWeightto;
      let dry = this.dry;
      let s_p_fodder = this.s_p_fodder;
      let dryM1 = this.dryM1;
      let dryM2 = this.dryM2;
      let dryM3 = this.dryM3;
      let greenFodder = this.greenFodder;
      let value = {
        liveWeightfrom,
        liveWeightto,
        dry,
        s_p_fodder,
        dryM1,
        dryM2,
        dryM3,
        greenFodder,
      };
      let data = { id, value };
      APIService.bodyWeightUpdate(data).then((res) => {
        if (res.status == 200) {
          (this.liveWeightfrom = ""),
            (this.liveWeightto = ""),
            (this.dry = ""),
            (this.s_p_fodder = ""),
            (this.dryM1 = ""),
            (this.dryM2 = ""),
            (this.dryM3 = ""),
            (this.greenFodder = ""),
            (this.addButton = false);
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
          this.getbodyWeightList();
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Data Saved Successfully",
            showConfirmButton: false,
            timer: 2000,
          });
        }
      });
    },
    deleteSpecies() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success"
            );
            this.delete();
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    delete() {
      let id = this.editSpecies._id;
      let data = { id };
      APIService.bodyWeightDelete(data).then((res) => {
        if (res.status == 200) {
          (this.liveWeightfrom = ""),
            (this.liveWeightto = ""),
            (this.dry = ""),
            (this.s_p_fodder = ""),
            (this.dryM1 = ""),
            (this.dryM2 = ""),
            (this.dryM3 = ""),
            (this.greenFodder = ""),
            (this.addButton = false);
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
          (this.EditsaveButton = false), this.getbodyWeightList();
        }
      });
    },
  },

  created() {
    this.getbodyWeightList();
  },
};
</script>

<style scoped>
.my-icon svg {
  fill: #fff !important;
  stroke: #fff !important;
  stroke-width: 0px !important;
  width: 20px !important;
}
.adjust {
  padding-left: 0px;
  padding-right: 0px;
}
</style>
<style>
.md-menu-content {
  z-index: 999999 !important;
}

.visitsModal .modal-header {
  display: none;
}
.visitsModal .modal-container {
  max-width: 1100px;
  max-height: 620px;
  margin: 0px auto;
  position: relative;
  height: auto;
  width: auto;
}
.visitsModal .modal-footer {
  display: none;
}
.tab-pane-1 {
  width: 100% !important;
  height: 430px !important;
  overflow-y: scroll;
}
.tab-pane-2 {
  width: 100% !important;
  height: 430px !important;
  overflow-y: scroll;
}
.tab-pane-3 {
  width: 100% !important;
  height: 430px !important;
  overflow-y: scroll;
}
.tabClass {
  margin: 5px !important;
  box-shadow: none !important;
}
.tabClass .md-card-header {
  display: none;
}

.tabClass .md-card-content {
  padding: 15px !important;
}
.tabClass .md-card-content .tab-content {
  padding: 0px !important;
}

.image-container {
  max-width: 140px !important;
}

.vue__time-picker input.display-time {
  width: 100% !important;
  border-top: none;
  border-right: none;
  border-left: none;
}
.vue__time-picker {
  display: inline !important;
}
.mapPtag {
  z-index: 9999 !important;
  position: absolute;
  top: 80px;
  margin-left: 10px;
  background-color: white;
  padding-left: 5px;
  padding-right: 5px;
  border-radius: 5px;
}
</style>
